import React from 'react';
import { useLocation } from 'react-router-dom';

import { Button, FeaturedIcon } from '@myhealth-raccoon/components';

import { ContentContainer } from 'src/components/ContentContainer';
import { StickyBottomBar } from 'src/components/StickyBottomBar';
import { useClinicSelector } from 'src/hooks/useAsyncSelector';
import { useExit } from 'src/hooks/useExit';

export function UnableToSchedAppointment() {
    const location = useLocation();
    const { bannedLevel } = location.state || {}; // Destructure passed state
    const { data: clinic } = useClinicSelector();
    const exit = useExit();

    return (
        <>
            <ContentContainer className="flex-1 space-y-6 text-center lg:flex-none">
                <FeaturedIcon size="lg" color="error" className="mx-auto mb-8" />
                <h1 className="text-2xl font-medium text-gray-900">
                    We are currently unable to schedule an appointment for you
                </h1>
                {bannedLevel !== 'Level 2' && (
                    <p>
                        Please call the practice
                        {clinic?.phoneNumber ? `on ` : ''}{' '}
                        <a className="text-primary" href={`tel:${clinic?.phoneNumber}`}>
                            {clinic?.phoneNumber}{' '}
                        </a>
                        to speak with one of our friendly receptionists to book with your doctor!
                    </p>
                )}
                {bannedLevel === 'Level 2' && (
                    <p>
                        Please consult
                        <span className="text-primary">
                            {' '}
                            <a href="https://www.healthdirect.gov.au">https://www.healthdirect.gov.au</a>{' '}
                        </span>
                        for alternative practice in the area
                    </p>
                )}
            </ContentContainer>
            <StickyBottomBar>
                <Button className="w-full" color="gray" onClick={() => exit()}>
                    Exit
                </Button>
            </StickyBottomBar>
        </>
    );
}
